import { Divider, Grid } from '@material-ui/core';
import NumberFormat from 'react-number-format';
import styled from 'styled-components';
import { Vehicle } from 'types/vehicle';
import { SellerAlternativeOfferBlock } from './SellerOfferBlock';
import { ActionButton } from 'components/ActionButton';
import { ConfirmAcceptBuyerOfferModal } from '../../RoleRestrictedSection/SellerRestrictedSection/AlternativeAuctionComponent';
import { useDispatch, useSelector } from 'react-redux';
import { modalsToggle } from 'actions';

const StyledDivider = styled(Divider)`
  && {
    margin: 24px 0;
  }
`;

const StyledBold = styled.span`
  font-weight: 500;
  font-size: 16px;
`;

export const AlternativeAuctionBlock = ({ vehicle }: { vehicle: Vehicle }) => {
  const buyerOffer = vehicle.top_alternative_bid_offer;

  const user = useSelector((state: any) => state.user.user);

  const dispatch = useDispatch();

  const openAcceptModal = () => {
    dispatch(modalsToggle(`accept-alternative-offer-${vehicle.id}`));
  };

  return (
    <>
      <Grid container item>
        <Grid item container>
          <SellerAlternativeOfferBlock vehicle={vehicle} />
          <Grid item xs={12}>
            <StyledDivider />
          </Grid>
          <Grid container alignItems="center" justify="space-between">
            <StyledBold>
              <span>Buyer Offer: </span>
              {buyerOffer ? (
                <NumberFormat value={buyerOffer.amount} displayType="text" thousandSeparator prefix="$" />
              ) : (
                'N/A'
              )}
            </StyledBold>
            <Grid container alignItems="center" justify="space-between" xs={12} sm={4}>
              <ActionButton
                disabled={(!buyerOffer || vehicle.in_battle) && user.role !== 'admin'}
                onClick={openAcceptModal}
                colorVariant="accept"
                fullWidth
              >
                Accept Offer
              </ActionButton>
              <ConfirmAcceptBuyerOfferModal vehicleId={vehicle.id} offerAmount={buyerOffer?.amount} />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <StyledDivider />
        </Grid>
      </Grid>
    </>
  );
};
